import { createReducer, createAction } from "@reduxjs/toolkit";
import { adminRetrieveTrainingItems } from "./retrieve-training-items";
import type { TrainingFollowUpTrainingItemVM } from "@shared-kernel/application/ports/admin/admin-repository";
import type { RetrievalState } from "@redux/state/shared-types";

const initialState: RetrievalState<TrainingFollowUpTrainingItemVM[]> = { fetching: "idle", data: [] };

export const resetAdminTrainingItemsRetrieval = createAction("trainingFollowUps/resetAdminTrainingItems");

export const adminRetrieveTrainingItemsReducer = createReducer<RetrievalState<TrainingFollowUpTrainingItemVM[]>>(initialState, builder => {
  builder.addCase(adminRetrieveTrainingItems.fulfilled, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      fetching: "success",
    };
  });
  builder.addCase(adminRetrieveTrainingItems.pending, state => {
    return {
      ...state,
      fetching: "pending",
    };
  });
  builder.addCase(adminRetrieveTrainingItems.rejected, state => {
    return {
      ...state,
      fetching: "failed",
    };
  });
  builder.addCase(resetAdminTrainingItemsRetrieval, () => initialState);
});
